import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=71353020&"
import script from "./PanelLayout.vue?vue&type=script&lang=js&"
export * from "./PanelLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports